/* eslint-disable */
import Setting from '@/setting';

const datetime = {};

/**
 * @description 格式化
 * @param {String} date
 */
datetime.format = function(utc_datetime, type = 'datetime') {
    // console.log('date', date)
    // console.log('type', type)
    if (utc_datetime === '0001-01-01T00:00:00Z' || utc_datetime === null) {
        return '';
    }
    try {
        let result = '';
        // 转为正常的时间格式 年-月-日 时:分:秒
        var T_pos = utc_datetime.indexOf('T');
        var Z_pos = utc_datetime.indexOf('Z');
        var year_month_day = utc_datetime.substr(0, T_pos);
        var hour_minute_second = utc_datetime.substr(
            T_pos + 1,
            Z_pos - T_pos - 1
        );
        var new_datetime = year_month_day + ' ' + hour_minute_second;

        // 处理成为时间戳
        timestamp = new Date(Date.parse(new_datetime));
        timestamp = timestamp.getTime();
        timestamp = timestamp / 1000;

        // 增加8个小时，北京时间比utc时间多八个时区
        var timestamp = timestamp + 8 * 60 * 60;

        // 时间戳转为时间
        var beijing_datetime = new Date(parseInt(timestamp) * 1000);
        if (type === 'date') {
            result = beijing_datetime.toLocaleDateString();
        } else if (type === 'datetime') {
            result = beijing_datetime
                .toLocaleString('chinese', { hour12: false })
                .replace(/年|月/g, '-')
                .replace(/日/g, ' ');
        } else if (type === 'time') {
            result = beijing_datetime.toLocaleTimeString();
        } else {
            return beijing_datetime;
        }
        // console.log('result', result)
        if (result === 'Invalid Date') {
            return utc_datetime; // 不是日期,原样返回
        }
        return result;
    } catch (error) {
        return utc_datetime; // 处理失败,原样返回
    }
};

//存在0点叫12点的bug
datetime.format1 = function(date, type = 'datetime') {
    // console.log('date', date)
    // console.log('type', type)
    if (date === '0001-01-01T00:00:00Z' || date === null) {
        return '';
    }
    try {
        let result = '';
        if (type === 'date') {
            result = new Date(date).toLocaleDateString();
        } else if (type === 'datetime') {
            result = new Date(date).toLocaleString();
        } else if (type === 'time') {
            result = new Date(date).toLocaleTimeString();
        } else {
            return date;
        }
        // console.log('result', result)
        if (result === 'Invalid Date') {
            return date; // 不是日期,原样返回
        }
        return result;
    } catch (error) {
        return date; // 处理失败,原样返回
    }
};

export default datetime;
